import i18n from "../i18n"

export const defaultLng = 101.450761
export const defaultLat = 0.526719

export const EVENT_LINK_PEMPEM = "welcome_pempem_io"
export const EVENT_LINK_PLAYSTORE = "welcome_playstore"
export const EVENT_LINK_APP = "welcome_pempem_app"
export const EVENT_LINK_PHONE = "welcome_phone"
export const EVENT_LINK_WHATSAPP = "welcome_whatsapp"
export const EVENT_MAP_MOVED = "welcome_map_moved"

export const WHATSAPP_LINK = "https://wa.me/6281944222166?text=Hai%20PemPem%2C%20saya%20tertarik%20untuk%20berniaga%20atau%20menjual%20buah%20sawit%20melalui%20PemPem.%20Mohon%20informasinya%20lebih%20lanjutnya.%20Terima%20kasih"

export const REDIRECT_URL = "https://poapp.pempem.org/applinks?destination=app&referrer=dest%3Dprice_map%26origin%3Dwelcome"

export function toIndoFormat(value: number, maxDigit: number = 0): string {
    return Intl.NumberFormat('id-ID', {
        minimumFractionDigits: 0,
        maximumFractionDigits: maxDigit
    }).format(value)
}

export function sendTapEvent(value: string) {
    window.gtag("event", "pp_tap_link", { pp_link: value });
}

export function isEnglish() {
    return i18n.language.includes('en')
}

export function isArrayNullOrEmpty(array: any[]|undefined) {
    return array === null || array === undefined || array.length === 0
}